<template>
  <div>
    <Row>
      <Col :span="spanLeftWidth" style="padding-right: 2px;">
      <Card class="cardboard" :style="{minHeight:'79vh',minWidth:'40px',padding:'auto',textAlign:!isClose?'left':'center'}">
        <p slot="title" :style="{display:isFolderTitleShow?'inline':'none'}">
          <Icon type="md-folder" size="24" color="#FFCB0F" />
          上传文件归档
        </p>
        <a href="#" :slot="slotIcon" @click.prevent="changeLimit">
          <Icon type="md-swap" size="20" />
        </a>

       <UserFolder ref="uFolder" :style="{display:isFolderHide?'inline':'none'}" @on-folder-open="onFolderOpen" @on-folder-delete="onFolderOpen"/>
      </Card>
      </Col>
      <Col :span="spanRightWidth">
      <Card class="cardboard" :style="{minHeight:'79vh'}">
        <p slot="title">
          <!--  <Icon type="ios-film-outline"></Icon> -->
          <Icon type="" size="24" color="#FFCB0F" />
          上传文件列表
        </p>
        <MyCloudList ref="myUploadList" @on-load-complete="onCloudListLoadComplete"></MyCloudList>
      </Card>
      </Col>
    </Row>
    <Drawer title="上传文件库" placement="left" :closable="false" v-model="value2" :width="600" :mask="true">
      <!-- show layer 未开放  -->
      <!-- <MyCloudList ref="myCloudList"></MyCloudList> -->
    </Drawer>
  </div>
</template>
<script>
import SearchMain from './../common/common_engine/search_main.vue'
import MainCloudList from './content_main_list.vue'
import WorkBook from './workbook_content.vue'
// import Folder from './file_folder.vue'
import userFolder from './docfolder.vue'
import { mapGetters } from 'vuex'
import store from '../../store'
import eventBus from "../../components/common/event_bus.js"
export default {
  name: "Cloud_Content_Main",
  inject: ["reload","activeselector"],
  data() {
    return {
      value1: ["1", "2"],
      value3: ["1"],
      //classid: "",
      pageType: "",
      cloudshow: false,
      workbookshow: false,
      value2: false,
      spanLeftWidth: 6,
      spanRightWidth: 18,
      isClose: false,
      minWidth: 100,
      isFolderHide: true,
      isFolderTitleShow: true,
      slotIcon: "extra",
      currentFolderId: "",
      folderFiles:0,//当前文件夹下的文件数量
      //isFirstSearch:false,
    }
  },
  provide() {
    return {
      expand: this.expand,
    }
  },
  components: {
    // 'SearchResult': tableresult,
    //'SearchEngine': SearchEngine,
    // 'treatyEngine': treatyEngine,
    // 'TradeEngine': ForeignTrade,
    'SearchEngine': SearchMain,
    'MyCloudList': MainCloudList,
    'MyWorkBook': WorkBook,
    // "Folder": Folder,
    "UserFolder":userFolder,
  },
  methods: {
    onFolderOpen(node) {
      //console.log('onFolderOpen:' + folderid)
      console.log('onFolderOpen==>')
      console.log(node)
      //点击文件夹清空树的选择
      this.$emit('clear-tree-select')
      //激活树
      this.activeselector()
      this.$refs.myUploadList.isFirstSearch=true
      //this.currentFolderId=folderid
      // if(folderid==="001"){
      //   this.$emit('on-load-complete')
      //   return
      // }
      //重置查询条件
      this.$refs.myUploadList.$refs.cloudSearchBar.resetCondition()
      this.$refs.myUploadList.formItem.text=""
      this.$refs.myUploadList.formItem.time=[]
      this.$refs.myUploadList.formItem.fileforce={}
      this.$refs.myUploadList.currentNode={}
      this.$refs.myUploadList.searchReset()

      this.$nextTick(function() {
        //清空上传文件列表选择状态
        //this.$refs.myUploadList.$refs.cloudFiles.showCheckBox(false)
        //触发选择文件夹时,先判定上传文件列表是否时可选状态，是则关闭选择状态
        var tableShowChecked=this.$refs.myUploadList.$refs.cloudFiles.showChkBox
        if(tableShowChecked){
          this.$refs.myUploadList.$refs.cloudResultTag.cancelConfirm()
        }
        // if(folderid==="001"){
        //   console.log("cancel 001")
        //   this.$refs.myUploadList.$refs.cloudResultTag.cancelConfirm()
        // }

        this.$refs.myUploadList.setFolderId(node.value)
        // this.$refs.myUploadList.setClassId(this.getclassid())
        this.$refs.myUploadList.getUserCloudFiles(1)
      })
    },
    onCloudListLoadComplete(tempTag) {
      console.log('onCloudListLoadComplete====>')
      console.log(tempTag)
      this.folderFiles=tempTag.total
      this.$refs.uFolder.setTotalFiles(this.folderFiles)//设置文件夹下的文件数量
      //this.$refs.myFolder.spinShow = false
      //上传文件列表加载完成，清空选中状态
       // this.$nextTick(function() {
       //  this.$refs.myUploadList.$refs.cloudResultTag.cancelConfirm()
       //  })
      
    },
    changeLimit() {
      this.isClose = !this.isClose
      //console.log('isClose:'+this.isClose)
      if (!this.isClose) {
        console.log('isClose:' + this.isClose + ",展开")
        if (this.sliderLength === 0) {
          this.normalScreen()
        } else if (this.sliderLength === 1) {
          this.twoScreen()
        } else {
          let b = store.getters.getLeftExpand
          if (b) { //若3屏展开状态点击文件夹展开则收缩
            eventBus.$emit("auto-expand")
          }
          this.twoScreen()
        }
      } else {
        console.log('isClose:' + this.isClose + ",收縮")
        if (this.sliderLength === 0) {
          this.shrinkfolder()
        } else if (this.sliderLength === 1) {
          this.shrinkfolder2()
        } else {
          this.shrinkfolder3()
        }

      }

    },
    normalScreen() {
      this.spanLeftWidth = "6"
      this.spanRightWidth = "18"
      this.isFolderTitleShow = true
      this.isFolderHide = true
      this.slotIcon = "extra"
      this.isClose = false
    },
    twoScreen() {
      this.spanLeftWidth = "12"
      this.spanRightWidth = "12"
      this.isFolderTitleShow = true
      this.isFolderHide = true
      this.slotIcon = "extra"
      this.isClose = false

    },
    threeScreen() {
      this.spanLeftWidth = "12"
      this.spanRightWidth = "12"
      this.isFolderTitleShow = true
      this.isFolderHide = true
      this.slotIcon = "extra"
      this.isClose = false
    },
    hidefolder() {
      this.spanLeftWidth = "12"
      this.spanRightWidth = "12"
      this.isFolderTitleShow = true
    },
    shrinkfolder() {
      this.spanLeftWidth = "1"
      this.spanRightWidth = "23"
      this.isFolderTitleShow = false
      this.isFolderHide = false
      this.slotIcon = "title"
    },
    shrinkfolder2() {
      this.spanLeftWidth = "2"
      this.spanRightWidth = "22"
      this.isFolderTitleShow = false
      this.isFolderHide = false
      this.slotIcon = "title"
    },
    shrinkfolder3() {
      this.spanLeftWidth = "4"
      this.spanRightWidth = "20"
      this.isFolderTitleShow = false
      this.isFolderHide = false
      this.slotIcon = "title"
    },
    expand() {
      this.vaule1 = ["1", "2"];
      this.reload();

    },
    switch (type) {
      //console.log("switch type:"+type)
      if (this.pageType == "mycloud") {
        this.cloudshow = true;
        this.vaule1 = ["1"]
      } else if (this.pageType == "mydoc") {
        this.workbookshow = true;
      } else {
        this.cloudshow = true;
      }
      //console.log(this.isExpand)
      // this.expand()
    },
    showSearchResult() {
      this.$refs.searchEngineComplex.onSearch()
    },
    onWorkBookSubmitOK() {
      //this.$refs.searchEngineComplex.reset()
    },
    onWorkBookSave() {
      //this.$refs.searchEngineComplex.reset()
    },
    showLayerUpload() {
      console.log("showLayerUpload")
      this.$refs.myCloudList.getUserCloudFiles(1)
      this.$refs.myCloudList.reloadHeaderData(['h1']);
      this.value2 = true
    },
    closelayer() {
      this.value2 = false
    }
    // setstatus(data) {

    // },
    // fliterHeader(obj) {
    //   this.$refs.search_rlt.reloadHeaderData(obj);
    // },
    // setmsgpad() {
    //   this.$refs.treatengine01.setSmallPadLeft();
    // }

  },
  mounted: function() {
    this.pageType = this.$route.query.q_type
    this.switch(this.pageType)
    let b = store.getters.getLeftExpand
    if (this.sliderLength === 1) {
      this.twoScreen()
    }
    if (this.sliderLength > 1) {
      if (b) {
        eventBus.$emit("auto-expand")
      }
      this.threeScreen()
    }
    // if (this.pageType == "mycloud") {
    //   this.cloudshow = true;
    // } else if (this.pageType == "mydoc") {
    //   this.workbookshow = true;
    // } else {
    //   this.cloudshow = true;
    // }
    //console.log(this.classid)
  },
  created() {

  },
  computed: {
    ...mapGetters(['sliderLength', 'getLeftExpand', 'sta'])
  },
  watch: {
    sliderLength: function(value) {
      let b = store.getters.getLeftExpand
      //console.log('分屏数量:' + value)
      if (value === 0) {
        if (!b) {
          eventBus.$emit("auto-expand")
        }
        this.normalScreen()
      } else if (value === 1) {
        if (b) {
          eventBus.$emit("auto-expand")
        }
        this.twoScreen()
      } else if (value > 1) {
        if (b) {
          eventBus.$emit("auto-expand")
        }
        this.threeScreen()
      }
      //this.changeLimit()

    },
    getLeftExpand: function(v) {
      console.log('expand:' + v)
      console.log('isClose:' + this.isClose)
      console.log('sliderLength:' + this.sliderLength)
      if (v && this.sliderLength >= 1 && !this.isClose) {
        this.changeLimit()
      }
    }
    // '$route'(to, from) {
    //   //刷新参数放到这里里面去触发就可以刷新相同界面了
    //   //this.getStatus(this.$route.path)
    //   console.log(this.$route.query.q_type)
    // }

  }

}

</script>
<style scoped>
.cpllapse-panel-title {
  font-size: 14px;
}

.expand-row {
  margin-bottom: 16px;
}

Col {
  display: inline;
}

.cardboard{
  height: 82vh;
  overflow-y: auto;
}
</style>
